package horcrux.frontend.common.views.documents

import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.common.types.DocumentContainer
import horcrux.common.utils.ifThen
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.components.containers.VStack
import mui.icons.material.Folder
import mui.icons.material.InsertDriveFile
import mui.material.Box
import mui.material.IconButton
import mui.material.Typography
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC
import react.Props
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.Overflow
import web.cssom.Position
import web.cssom.TextAlign
import web.cssom.WhiteSpace
import web.cssom.WordWrap
import web.cssom.px

external interface DocumentIconProps : Props {
    var label: String
    var documentMetadata: DocumentMetadata
    var showDialogState: BooleanState
}

val DocumentIcon = FC<DocumentIconProps> { props ->
    val maxLabelLength = 30
    val length = 75.px
    IconButton {
        VStack {
            this.sx {
                this.maxWidth = length
                this.overflow = Overflow.hidden
                this.whiteSpace = WhiteSpace.normal
                this.wordWrap = WordWrap.breakWord
            }
            Box {
                this.sx {
                    this.display = Display.inlineFlex
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.center
                    this.width = length
                    this.height = length
                    this.position = Position.relative
                }
                when (props.documentMetadata.documentType.documentTypeIdentifier) {
                    DocumentContainer -> Folder
                    else -> InsertDriveFile
                } {
                    this.sx {
                        this.fontSize = length
                        this.color = StaticContentConfigs.BLUE
                    }
                }

                Typography {
                    +props.documentMetadata.documentType.displayName
                    this.sx {
                        this.position = Position.absolute
                        this.color = StaticContentConfigs.WHITE
                        this.textAlign = TextAlign.center
                    }
                }
            }
            props.label.let { label ->
                label.ifThen(label.length > maxLabelLength) {
                    "${
                        this.take(
                            maxLabelLength
                        )
                    }..."
                }
            }.let {
                Typography {
                    +it
                    this.variant = TypographyVariant.caption

                    this.sx {
                        this.color = StaticContentConfigs.GRAY
                    }
                }
            }
            this.onClick = {
                props.showDialogState.setTrue()
            }
        }
    }
}
